import { Button } from "@mui/material";
import { DynamicFormControl }from "../../../";
/** Button to submit the form */
function SubmitButtonControl({ disabled, label, style }: {
    disabled: boolean,
    label?: string | undefined,
    style?: any
  }) {
    return (
        // <Button variant="contained" disabled={loading} color="primary" type="submit">Submit</Button>
        <Button disabled={disabled} variant="contained" color="primary" type="submit">{label ?? "Submit"}</Button>
    )
}


export default SubmitButtonControl;